import { WatchQueryFetchPolicy } from "apollo-boost";

export const defaultPollingInterval = 15000; // 30 sec

export const defaultPollingNoCacheParameters = {pollInterval: defaultPollingInterval, fetchPolicy: "no-cache" as WatchQueryFetchPolicy};